import Accordion from '../collapse-expand-block/design-1';
import Placeholder from './design-1';
import '../collapse-expand-block/index.css';

export default function Design6(props) {
    return props.state === 'placeholder'
        ? <Placeholder {...props}/>
        : <Accordion {...props}/>;
}
